export default () => {
  const reason = ref('')
  const reasonOrther = ref('')

  const reasonOptions = [
    {
      key: 'requiredPartner',
      label: 'Đội xe yêu cầu'
    },
    {
      key: 'requiredCustomer',
      label: 'Khách hàng yêu cầu'
    },
    {
      key: 'other',
      label: 'Khác'
    }
  ]

  const CReasonLabel = computed(() => {
    if (!reason.value) {
      return ''
    }

    if (reason.value === 'other') {
      return reasonOrther.value
    }

    const item = reasonOptions.find((r) => r.key === reason.value)

    if (item) {
      return item.label
    }

    return ''
  })

  const CDisabled = computed(() => {
    if (!reason.value) { return true }
    if (reason.value === 'other' && !reasonOrther.value) { return true }

    return false
  })

  return {
    reason,
    reasonOrther,
    reasonOptions,
    CReasonLabel,
    CDisabled
  }
}
